import { createFrontendPlugin, PageBlueprint, createRouteRef } from '@backstage/frontend-plugin-api';
import { RequireExternalPageAccess } from './RequireExternalPageAccess';

export const staticExternalPageRouteRef = createRouteRef();

export function externalPagePath(pageId: string): string {
  return `/external-pages/${pageId}`;
}

const externalPagePage = PageBlueprint.make({
  name: 'external-page',
  params: {
    path: '/external-pages/:pageId',
    routeRef: staticExternalPageRouteRef,
    loader: async () => <RequireExternalPageAccess />,
  },
});

export const staticExternalPagesPlugin = createFrontendPlugin({
  pluginId: 'static-external-pages',
  routes: { externalPage: staticExternalPageRouteRef },
  extensions: [externalPagePage],
});
